import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'documents/document';
const wizardName = 'Generic File association';
const wizardObject = 'Document';
const wizardAction = 'genericFileAssociation';

const GenericFileAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const { item, save, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, true);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "required": true,
                                "className": "col-12",
                                "icon": "faFile"
                            },
                            "type": {
                                "type": "select",
                                "required": true,
                                "options": [
                                    {
                                        "label": "companyLogo",
                                        "value": "companyLogo"
                                    },
                                    {
                                        "label": "companyBalance",
                                        "value": "companyBalance"
                                    },
                                    {
                                        "label": "companyRegistrationDocument",
                                        "value": "companyRegistrationDocument"
                                    },
                                    {
                                        "label": "companyRisk",
                                        "value": "companyRisk"
                                    },
                                ],
                                "className": "col-12",
                                "icon": "faCircleX"
                            },
                            "documentIdentifier": {
                                "type": "text",
                                "className": "col-3",
                                "icon": "faAddressCard"
                            },
                            "documentIssuer": {
                                "type": "text",
                                "className": "col-3",
                                "icon": "faBuilding"
                            },
                            "valid_at": {
                                "type": "date",
                                "className": "col-3"
                            },
                            "expire_at": {
                                "type": "date",
                                "className": "col-3"
                            },
                            "legalEntity": {
                                "type": "relationshipSingle",
                                "relation": {
                                    "drawerRoute": "legalentities",
                                    "inverseRelation": "document",
                                    "inverseRelationType": "relationshipSingle"
                                },
                                "view": "legalEntity"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters })
    }

    const legalEntity = discover('legalEntity');
    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                //"id": item?.data?._id, QUESTO ID NON VA PASSATO, NON 
                "legalEntity": legalEntity,
                "visibleToDriver": "false",
                "name": t("document") + (legalEntity?.name ? ' ' + legalEntity?.name : '')
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Add a {{wizardObject}} to {{fullname}}', { wizardObject: wizardObject, fullname: legalEntity?.name })}
                />
            }
            {...params}
        />
    </>
}

export default GenericFileAssociation;


